import styled from "styled-components";
import {cta_section} from "../../../assets/images";


const CTASection = () => {
  return (
    <SectionContainer>
      
      <ContentWrapper>
         <ContentContainer>
      <MainHeading>Empower Students, Elevate Institutions</MainHeading>
      <Description>Unlock potential with AI-driven insights that support both students and institutions.</Description>
    </ContentContainer>
        
        <CTAButton >
          Schedule a Demo
        </CTAButton>
      </ContentWrapper>
    </SectionContainer>
  );
};

const CTAButton = ({ children }) => {
  return (
    <ButtonContainer onClick={() => window.open("https://calendly.com/campusinsights-info/30min", "_blank")}>
      <ButtonText>{children}</ButtonText>
      <IconWrapper>
        <svg
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="arrow-icon"
        >
          <g clipPath="url(#clip0_356_944)">
            <path
              d="M15.5 5L14.09 6.41L18.67 11H2.5V13H18.67L14.08 17.59L15.5 19L22.5 12L15.5 5Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_356_944">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </IconWrapper>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.button`
  display: flex;
  height: 48px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 16px;
  border: 2px solid rgba(255, 255, 255, 0.7);
  background: linear-gradient(90deg, #5ea1ff 0%, #6a37e3 56.38%);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.1);

  cursor: pointer;

  @media (max-width: 640px) {
    width: 100%;
    max-width: 200px;
  }
`;

const ButtonText = styled.span`
  color: #fff;
  text-align: center;
  letter-spacing: -0.075px;
  font: 700 15px/140% Inter, -apple-system, Roboto, Helvetica, sans-serif;
  
  @media (max-width: 640px) {
    font-size: 13px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .arrow-icon {
    width: 24px;
    height: 24px;
    aspect-ratio: 1/1;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  width: 603px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex-shrink: 0;

  @media (max-width: 991px) {
    width: 100%;
    max-width: 600px;
    align-items: center;
    text-align: center;
  }
`;

const MainHeading = styled.h1`
  width: 606px;
  color: #fff;
  letter-spacing: -0.32px;
  font: 700 32px/120% Inter, -apple-system, Roboto, Helvetica, sans-serif;

  @media (max-width: 991px) {
    width: 100%;
    font-size: 28px;
  }

  @media (max-width: 640px) {
    font-size: 24px;
    line-height: 130%;
  }
`;

const Description = styled.p`
  align-self: stretch;
  color: #fff;
  letter-spacing: -0.08px;
  font: 400 16px/160% Inter, -apple-system, Roboto, Helvetica, sans-serif;

  @media (max-width: 991px) {
    font-size: 15px;
  }

  @media (max-width: 640px) {
    font-size: 14px;
  }
`;

const SectionContainer = styled.section`
  width: 100%;
  // height: 258px;
  position: relative;
  background-image: url(${cta_section});
  background-size: cover;
  background-position: center;
  overflow: hidden;

  @media (max-width: 640px) {
    height: auto;
    min-height: 200px;
  }
`;


const ContentWrapper = styled.div`
  display: flex;
  height: 100%;
  padding: 40px 32px;
  justify-content: center;
  align-items: center;
  gap: 200px;
  background: linear-gradient(
    90deg,
    rgba(56, 27, 121, 0.95) 0%,
    rgba(142, 106, 226, 0.51) 100%
  );

  @media (max-width: 991px) {
    flex-direction: column;
    gap: 32px;
    padding: 40px 24px;
  }

  @media (max-width: 640px) {
    padding: 32px 16px;
    gap: 24px;
  }
`;

export default CTASection;
